import { Center, Stack, Text } from "@mantine/core";
import { round } from "mathjs";

import { pass } from "@/libraries/pass";
import clsx from "clsx";

interface EngagementInsightsBarProps {
  value: number | null;
  label: string;
  color: string;
  skeleton?: boolean;
}

export function EngagementInsightsBar({
  value,
  label,
  color,
  skeleton,
}: EngagementInsightsBarProps) {
  return (
    <Stack gap={6} justify="center" flex={1}>
      <Center
        c={`${color}.9`}
        bg={`${color}.3`}
        className={clsx("rounded-2xl", {
          skeleton,
        })}
        py={12}
        flex={1}
        ta="center"
      >
        {round(pass.number(value), 2)}%
      </Center>
      <Text
        ta="center"
        className={clsx("self-center text-primary-text-body prose-sm/medium", {
          skeleton,
        })}
      >
        {label}
      </Text>
    </Stack>
  );
}
